import { Component, Input, OnInit } from '@angular/core';
import Windowsticker from '../../../../model/product/windowsticker/windowsticker';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Project } from 'src/app/model/project/project';
import Asset from 'src/app/model/asset';
import CustomWindowsticker from '../../../../model/product/windowsticker/custom-windowsticker';
import ProductHelper from '../../../../helpers/product-helper';
import ProductPhoneNumber from '../../../../model/product/product-phone-number';
import { SubProject } from '../../../../model/project/sub-project';
import StandardStickerPart from 'src/app/model/product/windowsticker/standard-sticker-part';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import { DO_CHECK_DEBOUNCE_TIME } from 'src/globals/globals';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import ProductPhoneNumberGroup from 'src/app/display-model/product-phone-number-group';
import { FormatPhoneNumber } from 'src/app/modules/app-pipes/format-phonenumber';
import Company from 'src/app/model/company/company';
import { FileHelper } from '../../../../helpers/file-helper';

@Component({
  selector: 'windowsticker-summary-card',
  templateUrl: './windowsticker-summary-card.component.html',
  styleUrls: ['./windowsticker-summary-card.component.scss'],
  providers: [FormatPhoneNumber],
})
export class WindowstickerSummaryCardComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  isCustom = false;
  customWindowSticker: CustomWindowsticker;
  @Input()
  inputWindowSticker: Windowsticker;
  @Input()
  inputSubProject: SubProject;
  @Input()
  inputProject: Project;
  @Input()
  index = 0;
  @Input()
  client = false;
  definitiveDesign: Asset[];
  isImage = FileHelper.isImage;
  typeTranslation: string;
  temporaryMaterialDisplay: string;
  standardStickerPartDisplays: StandardStickerPartDisplay[] = [];
  projectContactToCompany = new Map<number, Company>();
  productPhoneNumberGroups: ProductPhoneNumberGroup[] = [];
  multiplePhoneNumbers: boolean = false;

  constructor(
    public dialog: MatDialog,
    private projectDisplayObservableService: ProjectDisplayObservableService,
    private formatPhoneNumber: FormatPhoneNumber
  ) {
    super();
  }

  ngOnInit() {
    this.setDefinitiveDesign();
    if (this.inputWindowSticker.type === 'CustomWindowSticker') {
      this.isCustom = true;
      this.customWindowSticker = <CustomWindowsticker>this.inputWindowSticker;
    }
    this.typeTranslation = ProductHelper.getType(this.inputWindowSticker.type);
    this.temporaryMaterialDisplay = this.inputWindowSticker.temporaryMaterial
      ? 'Tijdelijk'
      : 'Permanent';
    this.calculateProjectContactToCompany();
    this.calculateProductPhoneNumberGroups();
    this.initializeSubscriptions();
  }

  initializeSubscriptions() {
    this.addSubscription(
      this.projectDisplayObservableService.getProductMaterialChangedSubscribable(),
      () => {
        this.temporaryMaterialDisplay = this.inputWindowSticker
          .temporaryMaterial
          ? 'Tijdelijk'
          : 'Permanent';
      }
    );
    this.addSubscription(
      this.projectDisplayObservableService.getProjectContactsChangedSubscribable(),
      () => {
        this.calculateProjectContactToCompany();
        this.calculateProductPhoneNumberGroups();
      },
      () => {},
      DO_CHECK_DEBOUNCE_TIME
    );
    this.addSubscription(
      this.projectDisplayObservableService.getProductPhoneNumberChangedSubscribable(),
      () => {
        this.calculateProjectContactToCompany();
        this.calculateProductPhoneNumberGroups();
      },
      () => {},
      DO_CHECK_DEBOUNCE_TIME
    );
    if (this.inputWindowSticker.type === 'WindowSticker') {
      this.calculateStandardStickerPartDisplays();
      this.addSubscription(
        this.projectDisplayObservableService.getProductMaterialChangedSubscribable(),
        () => {
          this.calculateStandardStickerPartDisplays();
        },
        () => {},
        DO_CHECK_DEBOUNCE_TIME
      );
      this.addSubscription(
        this.projectDisplayObservableService.getStandardStickerPartsChangedSubscribable(),
        () => {
          this.calculateStandardStickerPartDisplays();
        },
        () => {},
        DO_CHECK_DEBOUNCE_TIME
      );
    }
  }

  setDefinitiveDesign() {
    this.definitiveDesign = [];
    if (this.inputWindowSticker.productAssets) {
      for (let pa of this.inputWindowSticker.productAssets) {
        if (pa.formSection === 'internalDesign' && !pa.archived) {
          this.definitiveDesign.push(pa.asset);
        }
      }
    }
  }

  getCompanyName(ppn: ProductPhoneNumber) {
    if (ppn.projectContact != null) {
      for (let pc of this.inputProject.projectContacts) {
        if (ppn.projectContact.id === pc.id) {
          return pc.company.regularName;
        }
      }
    }
  }

  getTitle(title: string) {
    return title == null || title === '' ? 'Geen titel' : title;
  }

  getTypeTranslation(type) {
    return ProductHelper.getType(type);
  }

  getTemporary(temp) {
    if (temp) {
      return 'Tijdelijk';
    }
    return 'Permanent';
  }

  getWindowStickerSize(standardStickerPart: StandardStickerPart) {
    if (standardStickerPart.productSize != null) {
      let formaat = 'Liggend';
      if (
        standardStickerPart.productSize.height ===
        standardStickerPart.productSize.width
      ) {
        formaat = 'Vierkant';
      } else if (
        standardStickerPart.productSize.height >
        standardStickerPart.productSize.width
      ) {
        formaat = 'Staand';
      }
      return (
        formaat +
        ' / ' +
        standardStickerPart.productSize.height +
        ' cm h x ' +
        standardStickerPart.productSize.width +
        ' cm b'
      );
    }
  }

  getWindowStickerSizeWindow() {
    return (
      this.inputWindowSticker.windowLength +
      ' cm h x ' +
      this.inputWindowSticker.windowWidth +
      ' cm b'
    );
  }

  shortenName(name: string) {
    name = name.trim().replace(' ', '');
    let result = name.trim().replace(' ', '');
    let split = name.split('.');
    if (split.length > 1) {
      if (name.length > 8) {
        result =
          split[0].substring(0, 8 - split[split.length - 1].length) +
          '...' +
          split[split.length - 1];
      }
    }
    return result;
  }

  getCustomPrice(): number {
    let product = this.customWindowSticker;
    let result = 0;
    result += product.placementPrice;
    result += product.productionPrice;

    for (let line of product.prices) {
      let price = Number(line.price);
      result += price;
    }

    return result;
  }

  isEmpty(productPhoneNumber: ProductPhoneNumber) {
    return (
      productPhoneNumber.phoneNumbers == null ||
      productPhoneNumber.phoneNumbers === '' ||
      productPhoneNumber.phoneNumbers === 'Geen'
    );
  }

  nonEmptyPhoneNumber(): ProductPhoneNumber[] {
    let result = [];
    for (let ppn of this.inputWindowSticker.productPhoneNumbers) {
      if (!this.isEmpty(ppn)) {
        if (ppn.projectContact != null) {
          result.push(ppn);
        }
      }
    }
    return result;
  }

  atLeastTwoContactsWithPhoneNumber() {
    let companies = new Set<number>();
    for (let ppn of this.inputWindowSticker.productPhoneNumbers) {
      if (!this.isEmpty(ppn)) {
        companies.add(ppn.projectContact.id);
      }
      if (companies.size >= 2) {
        return true;
      }
    }
    return false;
  }

  getPhonesforCompanyName(cn: ProductPhoneNumber): ProductPhoneNumber[] {
    let result = [];
    for (let ppn of this.nonEmptyPhoneNumber()) {
      if (this.getCompanyName(cn) === this.getCompanyName(ppn)) {
        result.push(ppn);
      }
    }
    return result;
  }

  getNonEmptyPhoneNumbersForEachCompany(): ProductPhoneNumber[][] {
    let result = [];
    let companyNames = [];
    for (let nonempty of this.nonEmptyPhoneNumber()) {
      if (!companyNames.includes(this.getCompanyName(nonempty))) {
        companyNames.push(this.getCompanyName(nonempty));
        result.push(this.getPhonesforCompanyName(nonempty));
      }
    }
    return result;
  }

  calculateStandardStickerPartDisplays() {
    this.standardStickerPartDisplays = CollectionHelper.isPopulated(
      this.inputWindowSticker.standardStickerParts
    )
      ? this.inputWindowSticker.standardStickerParts.map((p) => {
          return {
            id: p.id,
            size: this.getWindowStickerSize(p),
            layoutDescription: p.layoutDescription,
          };
        })
      : [];
  }

  calculateProjectContactToCompany() {
    this.projectContactToCompany.clear();
    if (CollectionHelper.isPopulated(this.inputProject.projectContacts)) {
      this.inputProject.projectContacts.forEach((pc) => {
        if (pc.company != null) {
          this.projectContactToCompany.set(pc.id, pc.company);
        }
      });
    }
  }

  calculateProductPhoneNumberGroups() {
    if (!this.client || (this.client && this.inputProject.id != null)) {
      this.calculateProductPhoneNumbersWithExistingProjectContacts();
    } else {
      this.calculateProductPhoneNumbersClient();
    }
  }

  calculateProductPhoneNumbersWithExistingProjectContacts() {
    const companyToPhoneNumbers = new Map<number, ProductPhoneNumber[]>();
    if (
      CollectionHelper.isPopulated(this.inputWindowSticker.productPhoneNumbers)
    ) {
      this.inputWindowSticker.productPhoneNumbers.forEach((n) => {
        if (!this.isEmpty(n) && n.projectContact != null) {
          const company = this.projectContactToCompany.get(n.projectContact.id);
          if (company != null) {
            let arr = companyToPhoneNumbers.get(company.id);
            if (arr == null) {
              arr = [];
              companyToPhoneNumbers.set(company.id, arr);
            }
            arr.push(n);
          }
        }
      });
    }
    const groups: ProductPhoneNumberGroup[] = [];
    companyToPhoneNumbers.forEach((arr, companyId) => {
      if (CollectionHelper.isPopulated(arr)) {
        const company = this.projectContactToCompany.get(
          arr[0].projectContact.id
        );
        if (company != null) {
          const group: ProductPhoneNumberGroup = {
            companyId: companyId,
            companyName: company.regularName,
            phoneNumbers: arr.map((n) =>
              this.formatPhoneNumber.transform(n.phoneNumbers)
            ),
          };
          groups.push(group);
        }
      }
    });
    this.productPhoneNumberGroups = groups;
    this.multiplePhoneNumbers =
      groups.length > 1 || groups.some((g) => g.phoneNumbers.length > 1);
  }

  calculateProductPhoneNumbersClient() {
    const groups: ProductPhoneNumberGroup[] = [];

    if (
      CollectionHelper.isPopulated(this.inputProject.projectContacts) &&
      CollectionHelper.isPopulated(this.inputWindowSticker.productPhoneNumbers)
    ) {
      const group: ProductPhoneNumberGroup = {
        companyId: this.inputProject.projectContacts[0].company.id,
        companyName: this.inputProject.projectContacts[0].company.regularName,
        phoneNumbers: this.inputWindowSticker.productPhoneNumbers.map((n) =>
          this.formatPhoneNumber.transform(n.phoneNumbers)
        ),
      };
      groups.push(group);
    }

    this.productPhoneNumberGroups = groups;
    this.multiplePhoneNumbers =
      groups.length > 1 || groups.some((g) => g.phoneNumbers.length > 1);
  }

  trackById(index: number, obj: any): number {
    return GeneralHelper.trackById(index, obj);
  }
}

interface StandardStickerPartDisplay {
  id: number;
  size: string;
  layoutDescription: string;
}
